module.exports = __webpack_public_path__ + "img/armaBoca6.d583d3e4.jpg";